module.exports = __webpack_public_path__ + "static/media/card-testimonial1-square.88a5354d.png";